import FormLabel from './FormLabel'
import React, { useState } from 'react'

const TextArea = ({
  value,
  onChange,
  label,
  placeholder,
  isRequired = true,
  errorMessage,
  hasLabel = true,
  rows,
  disabled = false,
  limit = Infinity,
  defaultValue,
}) => {

  const setFormattedContent = (text) => {
    onChange(text.slice(0, limit))
  }

  return (
    <div className="mb-1 w-full">
      {hasLabel ? (
        <FormLabel label={label ?? placeholder} isRequired={isRequired} />
      ) : (
        ''
      )}

      <div className="w-full relative">
        <textarea
          className="form-control px-4"
          placeholder={placeholder}
          rows={rows ? rows : '4'}
          defaultValue={defaultValue}
          value={value}
          onChange={(event) => setFormattedContent(event.target.value)}
          disabled={disabled}
        />
        {limit !== Infinity && (
          <div className="flex justify-end text-sm">
            <span>{`${value.length} / ${limit}`}</span>
          </div>
        )}
      </div>

      <div className="text-xs text-error-500 h-4">{errorMessage}</div>
    </div>
  )
}

export default TextArea
